export const listToOptions = ({ data }, currentUser) => {
  return [currentUser, ...data].map((item) => {
    return {
      label: `${item.firstName} ${item.lastName}`,
      ...item,
    };
  });
};
